import PlanDetailPage from '@/components/PlanDetailPage';

const PricingCurbsideConsult = () => {
  return <PlanDetailPage planId="curbside-consult" />;
};

export default PricingCurbsideConsult;
